import { computed, Injectable, signal } from "@angular/core";
import { DataService } from "./data.service";
import { IUserInfo } from "../types/IUserinfo";
import { AppSettings } from "./app.settings";
import { HttpErrorResponse } from "@angular/common/http";
import { IProjekt } from "../types/IProjekt";

@Injectable({
    providedIn: 'root'
  })
  export class UserService {
  
    public userInfo = signal<IUserInfo | null>(null);
    public isAuthorized = computed(() => this.userInfo() !== null && this.userInfo()!.isActive && this.userInfo()!.rollenInfo !== null && this.userInfo()!.rollenInfo.length > 0);
    public userInfoInitialized = signal(false);
    

    constructor(private appSettings: AppSettings,
                private dataService: DataService) { 

    }

    initUserinfo(): Promise<void> {
        
        return new Promise<void>(
            (resolve) => {
                this.dataService.readUserinfo().subscribe({
                    next: (response) => {
                        if (response?.body) {
                            this.userInfo.set(response.body);
                            console.log('Userinfo - loaded from backend');
                            resolve();
                        } else {
                            this.clearUserInfo();
                            console.log('Userinfo - cleared local storage');
                            resolve();
                        }
                    },
                    error: (err: HttpErrorResponse) => {
                        // handle 401er
                        this.clearUserInfo();
                        console.error('Userinfo - cleared local storage');
                        resolve();
                    }, 
                    complete: () => {
                        console.log('Userinfo initialized');
                    }
                });
        });
    }

    clearUserInfo() {
        this.userInfo.set(null);
    } 


	IsBearbeitungPSTorPM(aktuelleBearbeitung: string) : boolean {
        if (this.userInfo() == null) 
            return false;

        return (this.userInfo()!.isProjektsteuerer && aktuelleBearbeitung ===  this.userInfo()?.alleRollen[0]) || 
               (this.userInfo()!.isProjektmanager && aktuelleBearbeitung ===  this.userInfo()?.alleRollen[1]);
    }

	HasUserAktuelleBearbeitung(aktuelleBearbeitung: string) : boolean {
        if (this.userInfo() == null) 
            return false;
        else if (this.userInfo()!.isAdministrator) 
            return true;
        else if (this.userInfo()!.isProjektsteuerer && aktuelleBearbeitung ===  this.userInfo()?.alleRollen[0]) 
            return true;
        else if (this.userInfo()!.isProjektmanager && aktuelleBearbeitung ===  this.userInfo()?.alleRollen[1])
            return true;
        else if (this.userInfo()!.isGebietskoordination && aktuelleBearbeitung ===  this.userInfo()?.alleRollen[2])
            return true;
        else if (this.userInfo()!.isTechnischeAufsicht && aktuelleBearbeitung ===  this.userInfo()?.alleRollen[3])
            return true;
        else if (this.userInfo()!.isFinanzcontrolling && aktuelleBearbeitung ===  this.userInfo()?.alleRollen[4])
            return true;
        else if (this.userInfo()!.isLeitungFinanzcontrolling && aktuelleBearbeitung ===  this.userInfo()?.alleRollen[5])
            return true;
        else if (this.userInfo()!.isGeschäftsführer && aktuelleBearbeitung ===  this.userInfo()?.alleRollen[6])
            return true;
        else 
            return false;     
    }

    AllowEdit(aktuelleBearbeitung: string, userID: number, firmaID: number, pmID: number) : boolean {
        return this.HasUserAktuelleBearbeitung(aktuelleBearbeitung) && this.userInfo()!.allowBudgetantragEdit && 
          (this.userInfo()!.isAdministrator || this.userInfo()!.userID === userID || (this.userInfo()!.isProjektsteuerer &&  this.userInfo()!.firmen.includes(firmaID))
          || (this.userInfo()!.isProjektmanager && this.userInfo()!.userID == pmID)); 
    }

    AllowBestaetigung(aktuelleBearbeitung: string) : boolean {
        return (this.HasUserAktuelleBearbeitung(aktuelleBearbeitung) || this.userInfo()!.isAdministrator)
    }

    AllowNewBudgetantrag(projekt:IProjekt) : boolean {
        return (this.userInfo()!.allowBudgetantragNew && (this.userInfo()!.isAdministrator || projekt.pm == this.userInfo()?.userShort || this.userInfo()!.firmen.includes(projekt.firmaID)));
    }
}
